import { render } from "./PopupTimKiemChuyenDi.vue?vue&type=template&id=196a2448&scoped=true"
import script from "./PopupTimKiemChuyenDi.vue?vue&type=script&lang=js"
export * from "./PopupTimKiemChuyenDi.vue?vue&type=script&lang=js"

import "./PopupTimKiemChuyenDi.vue?vue&type=style&index=0&id=196a2448&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196a2448"]])

export default __exports__